<template>
	
	<cc-modal :confirm="true" :showFooter="showFooter" @action="actionModal" yes="Accept & Continue" no="Decline">
		<div slot="body">
			<p class="mb-4 modal-header-quote">{{ this.headerMessage }}</p>
			<div class="row" v-if="!isProcessing">
				<template v-if="this.pq.paymentMethod != 'ETRANSFEROUT'">
					<div class="col-12 col-sm-5 text-center no-padding">
						<div class="row">
							<div class="col-12 no-padding">
								<h4 class="new-quote-header">Amount</h4>
							</div> 
						</div>
						<div class="row">
							<div class="col-12 no-padding">
								<span class="large-inputs-fiat large-inputs-fiat-modal new-quote-inputs">{{ $gstate.getCurrencySymbol(this.pq.fiatCurrency) }}{{ this.pq.fiatAmount | num2decimal }}</span>&nbsp;<span class="large-inputs-suffix new-quote-large-inputs-suffix">{{ this.pq.fiatCurrency }}</span>
							</div>
						</div>
					</div>
					<div class="col-12 col-sm-2 no-padding mt-3 mt-sm-0 mb-3 mb-sm-0">
						<div class="convert-icon new-quote-convert-icon mb-2" alt="Convert"></div>
					</div>
					<div class="col-12 col-sm-5 text-center no-padding">
						<div class="row">
							<div class="col-12 no-padding">
								<h4 class="new-quote-header">Receive</h4>
							</div>
						</div>
						<div class="row">
							<div class="col-12 large-inputs-crypto">
								<span class="large-inputs-crypto large-inputs-crypto-modal new-quote-inputs">{{ this.newPq.cryptoAmount | num8decimal }}</span>&nbsp;<span class="large-inputs-suffix new-quote-large-inputs-suffix">{{  this.newPq.cryptoCurrency }}</span>
							</div>
						</div>
					</div>
				</template>
				<template v-else>
					<div class="col-12 col-sm-5 text-center no-padding">
						<div class="row">
							<div class="col-12 no-padding">
								<h4 class="new-quote-header">Amount</h4>
							</div>
						</div>
						<div class="row">
							<div class="col-12">
								<span class="large-inputs-fiat-modal new-quote-inputs">{{ this.newPq.cryptoAmount | num8decimal }}</span>&nbsp;<span class="large-inputs-suffix new-quote-large-inputs-suffix">{{  this.newPq.cryptoCurrency }}</span>
							</div>
						</div>
					</div>
					<div class="col-12 col-sm-2 no-padding mt-3 mt-sm-0 mb-3 mb-sm-0">
						<div class="convert-icon new-quote-convert-icon mb-2" alt="Convert"></div>
					</div>
					<div class="col-12 col-sm-5 text-center no-padding">
						<div class="row">
							<div class="col-12 no-padding">
								<h4 class="new-quote-header">Receive</h4>
							</div> 
						</div>
						<div class="row">
							<div class="col-12 no-padding">
								<span class="large-inputs-fiat large-inputs-crypto large-inputs-crypto-modal new-quote-inputs">{{ $gstate.getCurrencySymbol(this.pq.fiatCurrency) }}{{ this.pq.fiatAmount | num2decimal }}</span>&nbsp;<span class="large-inputs-suffix new-quote-large-inputs-suffix">{{ this.pq.fiatCurrency }}</span>
							</div>
						</div>
					</div>
				</template>
			</div>
			<div class="row" v-else>
				<div class="col-12 text-center saving-quote">
					<template v-if="showProcessingMessage">{{ this.isProccessingMessage }} <i class="fas fa-circle-notch fa-spin"></i></template>
					<small class="error" v-if="hasError">{{ this.errorMessage }}</small>
				</div>
			</div>
		</div>
	</cc-modal>
</template>
<script>

import { eventBus } from './../main'

export default {
	mounted() {
		this.getNewQuote();
	},
	created(){
		this.headerMessage = "Your quote has expired.";
		this.isProccessingMessage = "Getting new quote ...";
	},
	data() {
		return {
			pq: this.$gstate.getFlowState(),
			newPq: null,
			isProcessing: true,
			isProccessingMessage: "",
			showProcessingMessage: true,
			hasError: true,
			errorMessage: "",
			showFooter: false,
			headerMessage: "",
		}
	},
	methods: {
		actionModal: function(action) {
			if(action == 'no'){
				this.$gstate.redirectHome(100, 0, 'modal decline');
			} else if (action == 'yes'){

				this.isProcessing = true;
				this.isProccessingMessage = "Saving quote ...";
				this.showFooter = false;

				// update the rate hold timer
				eventBus.$emit('updateTimer', this.newPq.txnValidUntil);
				eventBus.$emit('refreshPq');
				
				// close this component
				this.$emit('closeExpiredQuoteModal');

			}
		},
		getNewQuote: function(){

			this.hasError = false;
			this.isProcessing = true;
			
			var urlstr = this.$gstate.getApiBaseURL() + '/requote';
			var data = {
				refId: this.$gstate.getRefId(),
			}

			if(this.$gstate.getPaymentMethod() == 'ETRANSFEROUT'){
				data.cryptoAmount = this.$gstate.getFlowState().cryptoAmount;
			} else {
				data.fiatAmount = this.$gstate.getFlowState().fiatAmount;
			}

			this.axios.post(urlstr, data, this.$gstate.getAxiosHeaders())
				.then(response => {

					this.$gstate.log(response);
					this.newPq = response.data;

					this.isProcessing = false;
					this.showFooter = true;

					this.headerMessage = "Please review your new quote."

					this.$gstate.saveFlowState(response.data);
				
				})
				.catch(error => {
					this.hasError = true;
					this.errorMessage = error.response.data.error.msg;

					if(error.response.data.error.code == "SYSTEM"){

						this.showProcessingMessage = false;
						this.errorMessage += ".  Redirecting to homepage in 5 seconds..."

						this.$emit('setLeaveNotification', false);
						this.$gstate.redirectHome(100, 5000, this.errorMessage);

					}
				});
		}
	}
}
</script>